export default "__VITE_ASSET__cd607274__"